import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'people-schema/v4';

  pathForType(...args: Parameters<ApplicationAdapter['pathForType']>) {
    return super
      .pathForType(...args)
      .replace('peopleSchema/', '')
      .toLowerCase();
  }
}
